import { IonContent, IonInput, IonPage, IonText, IonTextarea, IonSpinner, IonIcon } from "@ionic/react"
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../Service/service";
import Head from "./Header"
import moment from "moment";
import Select from 'react-select';
import Sidebar from "./Sidebar"
import swal from 'sweetalert';
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const LeaveApply: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [data, setData] = useState([]);
    const [leaves, setleave] = useState([])
    const [remaining, setRemaning] = useState(0);
    const [totalleave, setTotalleave] = useState(0);
    const [leavelist, setleavelist] = useState('')
    const [id] = useState(localStorage.getItem('SignupEmpId'))
    const [noofdays, setNoodays] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });
    const [selectedDurations, setSelectedDurations] = useState<string[]>([]);
    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);
    const [dateto, setdateto] = useState('')

    const [leave, setLeave] = useState("");
    const [fDate, setFDate] = useState("");
    const [tDate, setTDate] = useState("");
    const [leaveRea, setLeaveRea] = useState("");
    const [day, setNoday] = useState("");
    const [casual, setcasual] = useState('');
    const [earned, setearned] = useState('');
    const [sick, setsick] = useState('')

    const [leaveTypeList, setLeaveTypeList] = useState<LeaveType[]>([]);
    const [selectedDuration, setSelectedDuration] = useState<string>("");

    interface LeaveType {
        id: string;
        leaveType: string;
    }

    /*................ View ...................... */

    const [leaveType, setLeaveType] = useState("");
    const [status, setStatus] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setTodate] = useState("");
    const [leaveReason, setLeaveReason] = useState("");
    const [reportingPerson, setReportingPerson] = useState("");
    const [NoOfDays, setNoOfDays] = useState("");
    const [dd, setdd] = useState([])
    const [remarks, setRemarks] = useState("");
    const [lopFlag, setLopFlag] = useState(0);
    const [statusFlag, setStatusFlag] = useState(true);

    const [status1, setStatus1] = useState("");
    const [days, setday] = useState('');
    const [no, setno] = useState('')
    const [empCode] = useState(localStorage.getItem("empCode"));

    /*................... Edit .................. */

    const [edit, setEdit] = useState(false);
    const [leaveId, setLeaveId] = useState("");

    const [statusList, setStatusList]: any = useState([]);

    //*******************LeaveType Autocomplete********************//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Leave Type</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const options = leaveTypeList.map((state: any) => ({
        value: state.id,
        label: state.leaveType,
    }));


    //************************Calculation for no of days ***********************//
    // const generateDayOptions = () => {
    //     const startDate = moment(fDate);
    //     const endDate = moment(tDate);
    //     const daysArray: { value: string; label: string }[] = [];

    //     if (startDate.isValid() && endDate.isValid() && endDate.isSameOrAfter(startDate)) {
    //         const days = endDate.diff(startDate, 'days') + 1;

    //         for (let i = days; i >= 0.5; i -= 0.5) {
    //             daysArray.push({ value: i.toString(), label: i.toString() });
    //         }
    //     }

    //     return daysArray.slice(0, 2);
    // };

    // const generateDayOptions1 = () => {
    //     const startsDate = moment(fromDate);
    //     const endsDate = moment(toDate);
    //     const daysArray: { value: string; label: string }[] = [];

    //     if (startsDate.isValid() && endsDate.isValid() && endsDate.isSameOrAfter(startsDate)) {
    //         const days = endsDate.diff(startsDate, 'days') + 1;

    //         for (let i = days; i >= 0.5; i -= 0.5) {
    //             daysArray.push({ value: i.toString(), label: i.toString() });
    //         }
    //     }
    //     return daysArray.slice(0, 2);
    // };

    /*...................Create Leave Auto complete .................. */

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };
    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };
    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };
    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };
    const handleFocus1 = () => {
        setIsFocused1(true);
    };
    const handleBlur1 = () => {
        setIsFocused1(false);
    };

    const Placeholder1 = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Leave Type</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const DropdownIndicator1: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const option = leaveTypeList.map((state: any) => ({
        value: state.id,
        label: state.leaveType,
    }));

    //*********************Days Autocomplete*******************//

    const [selectedOption2, setSelectedOption2] = useState(null);
    const [inputValue2, setInputValue2] = useState('');
    const [isFocused2, setIsFocused2] = useState(false);
    const [menuIsOpen2, setMenuIsOpen2] = useState(false);

    const handleStateChange2 = (selectedOption2: any) => {
        setSelectedOption2(selectedOption2);
    };
    const handleInputChange2 = (inputValue2: any) => {
        setInputValue2(inputValue2);
    };
    const handleMenuOpen2 = () => {
        setMenuIsOpen2(true);
    };
    const handleMenuClose2 = () => {
        setMenuIsOpen2(false);
    };
    const handleFocus2 = () => {
        setIsFocused2(true);
    };
    const handleBlur2 = () => {
        setIsFocused2(false);
    };

    const Placeholder2 = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select  Type</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const DropdownIndicator2: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const handletype = (selectedOption2: any) => {
        setday(selectedOption2.value)
    }
    const handletypes = (selectedOption: any) => {
        setno(selectedOption.value)
    }

    //********************* Loading ***********************//

    const [isLoading, setIsLoading] = useState(false);
    const currentDate = "2023-08-01";

    //************************Leavetype Api *********************//

    const GetLeaveType = () => {
        service.GetLeaveType()
            .then((response) => {
                if (response.status === 200) {

                    // const filteredLeaveTypes = response.data.data.filter((leaveType: any) => {
                    //     return leaveType.leaveType !== "Maternity" && leaveType.leaveType !== "Paternity" && leaveType.leaveType !== "Comp Off";
                    // });
                    setLeaveTypeList(response.data.data);
                    // setleave(response.data.data.id)
                }
                else {
                    setLeaveTypeList([]);
                }
            });
    }

    //***********************Leavetype status*********************//

    const hanldeLeaveType = (selectedOption: any) => {
        console.log(selectedOption.value, "id")
        setLeave(selectedOption.value);
        for (let i = 0; i < statusList.length; i++) {
            if (statusList[i].status === "Open") {
                setStatus(statusList[i].id);
            }
        }

        const selectedLeaveType = leaveTypeList.find((state: any) => state.id === selectedOption.value);
        if (selectedLeaveType && selectedLeaveType.leaveType === "Comp Off") {
            swal("", `Please indicate under 'Reason for Leave' the dates you worked`, "info");
        }
    };
    const hanldeUpdateLeaveType = (selectedOption1: any) => {
        setLeaveType(selectedOption1.value)
        const selectedLeaveType = leaveTypeList.find((state: any) => state.id === selectedOption1.value);
        if (selectedLeaveType && selectedLeaveType.leaveType === "Comp Off") {
            swal("", `Please indicate under 'Reason for Leave' the dates you worked`, "info");
        }

    }

    //**************************ViewModal**************************//

    // const openmodal = (itm: any) => {
    //     setModalopen(true);
    //     service.GetLeaveDetailsById(itm.id)
    //         .then((response) => {
    //             console.log(response, "lmlml")
    //             if (response.data.Status === "200") {
    //                 const leaveData = response.data.Data;

    //                 setLeaveId(leaveData.id);
    //                 setLeaveType(leaveData.leaveType.id);
    //                 setStatus(leaveData.leaveStatus.id);
    //                 setStatus1(leaveData.leaveStatus.status);
    //                 setFromDate(leaveData.fromDate);
    //                 setTodate(leaveData.toDate);
    //                 setLeaveReason(leaveData.reason);
    //                 setReportingPerson(leaveData.reportingPerson[0]);
    //                 setNoOfDays(leaveData.noOfDays);
    //                 setRemarks(leaveData.remarks);
    //                 setLopFlag(leaveData.lopFlag);
    //                 setStatusFlag(leaveData.status);

    //                 const fromDate = leaveData.fromDate;
    //                 const toDate = leaveData.toDate;
    //                 const empCode = leaveData.empCode;
    //                 const leaveTypeId = leaveData.leaveType.id;

    //                 service.NumberLeave(fromDate, toDate, empCode, leaveTypeId)
    //                     .then((numberLeaveResponse) => {
    //                         console.log(numberLeaveResponse);

    //                         if (numberLeaveResponse.data.status === 200) {
    //                             const noOfDays = numberLeaveResponse.data.data.noOfDays;
    //                             const data = noOfDays.map((state: any) => ({
    //                                 value: state,
    //                                 label: state.toString(),
    //                             }));

    //                             setdd(data);

    //                             const selectedValue = data.find((option: any) => option.value === parseFloat(leaveData.noOfDays))?.value;
    //                             setno(selectedValue);
    //                         }
    //                     })
    //                     .catch((error) => {
    //                         console.error("Error fetching number of leave days:", error);
    //                     });
    //             }
    //         })
    // }

    const openmodal = (itm: any) => {
        setModalopen(true);

        service.GetLeaveDetailsById(itm.id)
            .then((response) => {
                console.log(response, "lmlml");

                if (response.data && response.data.Status === "200") {
                    const leaveData = response.data.Data;

                    setLeaveId(leaveData.id);
                    setLeaveType(leaveData.leaveType.id);
                    setStatus(leaveData.leaveStatus.id);
                    setStatus1(leaveData.leaveStatus.status);
                    setFromDate(leaveData.fromDate);
                    setTodate(leaveData.toDate);
                    setLeaveReason(leaveData.reason);
                    setReportingPerson(leaveData.reportingPerson[0]);
                    setNoOfDays(leaveData.noOfDays);
                    setRemarks(leaveData.remarks);
                    setLopFlag(leaveData.lopFlag);
                    setStatusFlag(leaveData.status);

                    const fromDate = leaveData.fromDate;
                    const toDate = leaveData.toDate;
                    const empCode = leaveData.empCode;
                    const leaveTypeId = leaveData.leaveType.id;

                    service.NumberLeave(fromDate, toDate, empCode, leaveTypeId)
                        .then((numberLeaveResponse) => {
                            console.log(numberLeaveResponse);

                            if (numberLeaveResponse.data) {
                                const noOfDaysData = numberLeaveResponse.data.data.noOfDays;

                                const data: any = noOfDaysData.map((state: any) => ({
                                    value: state,
                                    label: state.toString(),
                                }));

                                setdd(data);

                                const selectedValue = data.find((option: any) => option.value === parseFloat(leaveData.noOfDays))?.value;
                                setno(selectedValue);
                            } else {
                                console.error("Invalid response format:", numberLeaveResponse);
                            }
                        })
                        .catch((error) => {
                            console.error("Error fetching number of leave days:", error);
                        });
                } else {
                    console.error("Invalid response format:", response.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching leave details:", error);
            });
    };


    const openmodal1 = () => {
        setModalopen1(true);
    }

    const editModal = () => {
        setEdit(true)
    }

    //************View Modal**************//

    const closemodal = () => {
        setModalopen(false);
        setEdit(false)
        setLeaveType("");
        setStatus("");
        // setFromDate("");
        // setTodate("");
        setLeaveReason("");
        setReportingPerson("");
        setNoOfDays("");
        setRemarks("");
        setLeaveId("");
    }

    //***************Apply Modal****************//

    const closemodal1 = () => {
        setModalopen1(false);
        setLeave("");
        setFDate("");
        setTDate('');
        setLeaveRea("");
        setNoodays([]);
        setday('');
    }

    //******************Apply Leave API*****************//

    const Save = () => {
        if (leave === "") {
            swal("", "Please Select Leave Type", "info");
            return;
        } else if (fDate === "") {
            swal("", "Please Select From Date", "info");
            return;
        } else if (tDate === "") {
            swal("", "Please Select To Date", "info");
            return;


        } else if (leaveRea === "") {
            swal("", "Please Enter Leave Reason", "info");
            return;
        }

        setIsLoading(true);

        setTimeout(() => {
            Leave();
        }, 1000);
    }
    const Leave = () => {
        const nodFloat = parseFloat(days);
        setIsLoading(true);
        service.ApplyLeave(fDate, tDate, leave, leaveRea, nodFloat, empCode, leaveId, status, reportingPerson, remarks, lopFlag, statusFlag)
            .then((response) => {
                console.log(response);
                if (response.data.Status === '200') {
                    swal("", "Applied Successfully", "success")
                        .then(() => {
                            setModalopen1(false);
                            window.location.reload();
                        });
                }
                else if (response.data.Status === '400') {
                    swal("", response.data.Message, 'error');
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    }


    //----------------UpdateLeave Api-------------------//

    const Update = () => {
        if (leaveType === "") {
            swal("", "Please Select Leave Type", "info");
            return;
        } else if (fromDate === "") {
            swal("", "Please Select From Date", "info");
            return;
        } else if (toDate === "") {
            swal("", "Please Select To Date", "info");
            return;
        } else if (NoOfDays === "") {
            swal("", "Please Enter No Of Days", "info");
            return;
        } else if (leaveReason === "") {
            swal("", "Please Enter Leave Reason", "info");
            return;
        }

        var noofDays = parseFloat(no);

        if (noofDays <= 0) {
            swal("", "No Of Days should be greater than 0", "info");
            return;
        } else if (/[^0-9.]/.test(no)) {
            swal("", "No Of Days should not contain symbols", "error");
            return;
        } else {
            var noofDays = parseFloat(no);
            setIsLoading(true);
            console.log(leaveId, "kmk");

            service.ApplyLeave(
                fromDate,
                toDate,
                leaveType,
                leaveReason,
                noofDays,
                empCode,
                leaveId,
                status,
                reportingPerson,
                remarks,
                lopFlag,
                statusFlag
            )
                .then((response) => {
                    console.log(response);
                    if (response.data.Status === '200') {
                        swal("", "Updated Successfully", "success").then(() => {
                            window.location.reload();
                        });
                        setModalopen(false);
                    } else {
                        swal("", response.data.Message, "error");
                    }
                })
                .catch((error) => {
                    console.error("Error during API call:", error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };

    //********************No of days calculation API*******************//

    const Leavecal = async (e: any, isFromDate: boolean) => {
        const selectedDate = e.detail.value;

        if (isFromDate) {
            setFDate(selectedDate);
        } else {
            setTDate(selectedDate);
        }

        const fromDate = isFromDate ? selectedDate : fDate;
        const toDate = isFromDate ? tDate : selectedDate;

        console.log(isFromDate, "kklkkl");

        if (fromDate && toDate && fromDate.length !== 0 && toDate.length !== 0) {
            try {
                const response = await service.NumberLeave(fromDate, toDate, empCode, leave);

                console.log(response);

                if (response.data.status === 200) {
                    var day = response.data.data.noOfDays;
                    var data = day.map((state: any) => ({
                        value: state,
                        label: state,
                    }));
                    setNoodays(data);
                    setday(day[0]);
                    console.log(day);
                }
                else if (response.data.status === 401) {
                    swal("", response.data.message.map((msg: any, index: any) => `${index + 1}. ${msg}`).join("\n"), "error").then(() => {
                        let newdata = response.data.data.fromdate;
                        setFDate(newdata);
                        console.log("newdata", newdata);

                        let newDateToSet = response.data.data.toDate;
                        setTDate(newDateToSet);
                        console.log("newdataset", newDateToSet);

                        var day = response.data.data.noOfDays;
                        var data = day.map((state: any) => ({
                            value: state,
                            label: state,
                        }));
                        setNoodays(data);
                        setday(day[0]);

                        if (response.data.message1) {
                            swal("", response.data.message1, "info").then(() => {
                                let newdata = response.data.data.fromdate;
                                setFDate(newdata);
                                console.log("newdata", newdata);

                                let newDateToSet = response.data.data.toDate;
                                setTDate(newDateToSet);
                                return;
                            })
                        }
                    });
                }

                // else if (response.data.Status === "401") {
                //     swal(response.data.Message).then(() => {
                //         let newdata = response.data.data.fromdate;
                //         setFDate(newdata);
                //         console.log("newdata", newdata);
                //         let newDateToSet = response.data.data.toDate;
                //         setTDate(newDateToSet);
                //         console.log("newdataset", newDateToSet);
                //         var day = response.data.data.noOfDays;
                //         var data = day.map((state: any) => ({
                //             value: state,
                //             label: state,
                //         }));
                //         setNoodays(data);
                //         setday(day[0]);
                //         if (response.data.message1) {
                //             swal(response.data.message1).then(() => {
                //                 return true; // You can handle the next steps here after the second swal
                //             });
                //         } else {
                //             return true; // Handle other cases if needed
                //         }
                //     })
                // }
                else {
                    if (response.data.status === 201) {
                        swal("", response.data.message, "info").then(() => {
                            // alert(response.data.message);
                            let newFromdata = response.data.data.fromdate;
                            setFDate(newFromdata);
                            let tdate = response.data.data.toDate
                            setTDate(tdate);
                            var day = response.data.data.noOfDays;
                            var data = day.map((state: any) => ({
                                value: state,
                                label: state,
                            }));
                            setNoodays(data);
                            setday(day[0]);

                        });
                    }
                    else if (response.data.Status === "400") {
                        swal("", response.data.Message, "info");
                    }
                }
            } catch (error) {
                console.error("Error fetching project data:", error);
            }
        }
    };

    //*******************Update No of leave calculation API***************//

    const updateLeavecal = (e: any, isFromDate: boolean) => {
        if (edit === true) {
            const selectedDate = e.detail.value;
            console.log(e.detail.value, "dates");
            if (isFromDate) {
                setFromDate(selectedDate);
            } else {
                setTodate(selectedDate);
            }
            service.updateNumberLeave(isFromDate ? selectedDate : fromDate, isFromDate ? toDate : selectedDate,
                empCode,
                leave,
                leaveId
            )
                .then((response) => {
                    console.log(response);
                    let newDateToSet = isFromDate ? selectedDate : toDate;

                    if (response.data.status === 200) {
                        var day = response.data.data.noOfDays;
                        var data = day.map((state: any) => ({
                            value: state,
                            label: state,
                        }));
                        setdd(data);
                        setno(day[0])
                        // let date = data.find((option: any) => option.value === parseFloat(NoOfDays))
                        // let selectedValue = date ? date.value : day;
                        // console.log(date, "lnhiiho");
                        // setno(selectedValue);
                        console.log(data, "lkijiojio")
                    }
                    else if (response.data.status === 401) {
                        swal("", response.data.message.map((msg: any, index: any) => `${index + 1}. ${msg}`).join("\n"), "error").then(() => {
                            let newdata = response.data.data.fromdate;
                            setFromDate(newdata);
                            console.log("newdata", newdata);
                            let newDateToSet = response.data.data.toDate;
                            setTodate(newDateToSet);
                            console.log("newdataset", newDateToSet);

                            var day = response.data.data.noOfDays;
                            var data = day.map((state: any) => ({
                                value: state,
                                label: state,
                            }));
                            setdd(data);
                            setno(day[0]);

                            // swal("", response.data.message1, "info");
                        });
                    }

                    else if (response.data.status === 201) {
                        swal("", response.data.message, "info").then(() => {
                            newDateToSet = response.data.data.toDate;
                            setTodate(newDateToSet);
                            let newFromdata = response.data.data.fromdate;
                            setFromDate(newFromdata);
                            var day = response.data.data.noOfDays;
                            var data = day.map((state: any) => ({
                                value: state,
                                label: state,
                            }));
                            setdd(data);
                            setno(day[0]);
                        });
                    }

                    else if (response.data.Status === "400") {
                        swal("", response.data.Message, "info");
                    }
                })
                .catch((error) => {
                    console.error("Error fetching project data:", error);
                });
        }
    };


    //----------------------Cancel Leave Api-----------------//

    const CancelLeave = () => {
        var nodFloat = parseFloat(NoOfDays);
        swal({
            title: "Do you want to Cancel your leave?",
            icon: "warning",
            dangerMode: true,
            buttons: {
                confirm: {
                    text: "Yes",
                    value: true,
                    visible: true,
                    className: "custom-swal-yes",
                    closeModal: true,
                },
                cancel: {
                    text: "No",
                    value: false,
                    visible: true,
                    className: "",
                    closeModal: true,

                },
            },
        })
            .then((willDelete) => {
                var sts: any;
                for (let i = 0; i < statusList.length; i++) {
                    if (statusList[i].status === "Cancelled") {
                        sts = statusList[i].id
                    }
                }
                if (willDelete) {
                    service.CancelLeave(fromDate, toDate, leaveType, leaveReason, nodFloat, empCode, leaveId, sts, reportingPerson, remarks, lopFlag, false)
                        .then((response) => {
                            console.log(response)
                            console.log("status is", sts)
                            window.location.reload();
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            });

    }

    useEffect(() => {
        GetLeaveCount();
        GetLeaveType();
        GetStatusList();
        LeaveListBalance();
        console.log("responseeeee=========>", leaveTypeList)

    }, []);

    //---------------------LeaveCount Api---------------//
    const GetLeaveCount = () => {
        setIsLoading(true);

        // Introduce a 2-second delay using setTimeout
        setTimeout(() => {
            service.ViewLeaveCount(id)
                .then((response) => {
                    console.log(response);
                    console.log("RESPONSE", response);
                    setData(response.data.Data);
                    // var val = response.data.Leaves.totalLeave - response.data.Leaves.balance
                    setTotalleave(response.data.Leaves.totalLeave);
                    setRemaning(response.data.balance);
                })
                .catch((error) => {
                    alert(error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }, 1000);
    };

    const GetStatusList = () => {
        service.GetLeaveStatusDropDown()
            .then((response) => {
                console.log(response);
                if (response.data.Status === "200") {
                    setStatusList(response.data.Data);
                }
                else {
                    setStatusList([]);
                }
            })
    }

    //********************Leave Balance API****************//

    const LeaveListBalance = () => {
        service.ViewLeaveCountInPopup(id)
            .then((response) => {
                console.log(response);
                if (response.data.status === 200) {
                    setleavelist(response.data.data);
                    // setearned(response.data.data.leaveTypeId);
                    // setsick(response.data.data.balance)
                    response.data.data.forEach((leave: any) => {
                        if (leave.leaveTypeId === 'Earned') {
                            setearned(leave.balance);
                        } else if (leave.leaveTypeId === 'Sick') {
                            setsick(leave.balance);
                        } else if (leave.leaveTypeId === 'Casual') {
                            setcasual(leave.balance)
                        }
                    });

                    // setsick(response.data.data[1].balance);
                    // setcasual(response.data.data[2].balance);
                    console.log('earned', response.data.data)
                }
                else {
                    setleavelist('');
                }
            })
    }

    //-------------LeaveApply Datatable------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px"
        },
        {
            name: "Leave Type",
            selector: (itm: any) => itm.leaveType.leaveType,
            sortable: true,
        },
        {
            name: "Days/Hours",
            selector: (itm: any) => itm.noOfDays,
            sortable: true,
        },
        {
            name: "Request Date",
            sortable: true,
            selector: (itm: any) => moment(itm.requestedDate).format("DD-MM-YYYY"),

        },
        {
            name: "Status",
            sortable: true,
            cell: (itm: any) => (
                <>
                    <IonText className={itm.leaveStatus.status === "Approved" ? "color_approve" : itm.leaveStatus.status === "Open" ? "color_progress" : "color_deny"}>{itm.leaveStatus.status}</IonText>
                </>
            )
        },
        {
            name: "Action",
            sortable: false,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ]


    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
                // paddingLeft:"0px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };
    const back = () => {
        history.goBack();
    }
    //-----------------Search filter------------------//

    const datatable = data.filter((item: any) => {
        const dateStr = item.requestedDate;
        const searchText = filterText.toLowerCase();
        const formattedDate = formatDateForComparison(dateStr);
        return (
            JSON.stringify(item).toLowerCase().includes(searchText) ||
            formattedDate.includes(searchText)
        );
    });
    function formatDateForComparison(dateStr: string) {
        const [day, month, year] = dateStr.split('-');
        return `${year}-${month}-${day}`;
    }

    //--------------------Search Filter-------------//

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    {/* <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button> */}
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        My Leaves</h3>
                                </div>
                                <div className="col-auto float-end ml-auto">
                                    <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Apply Leave</a>
                                </div>
                            </div>
                            <div className="row">
                                {/* <div className="col-md-3">
                                    <div className="stats-info">
                                        <h6 style={{ fontWeight: "bold" }}>Total Leave</h6>
                                        <h4 style={{ fontWeight: "bolder" }}>{totalleave}</h4>
                                    </div>
                                </div> */}
                                {/* <div className="col-md-3">
                                    <div className="stats-info">
                                        <h6 style={{ fontWeight: "bold" }}>Available Leave</h6>
                                        <h4 style={{ fontWeight: "bolder" }}>{remaining}</h4>
                                    </div>
                                </div> */}
                            </div>
                            {isLoading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive">
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* -----------------------View Leave Modal-------------------------- */}

                <Modal
                    dialogClassName="my-modal modal-dialog-centered"
                    id="logouts-modal"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Leave</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* <form> */}
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Leave Type <span className="text-danger">*</span></label>
                                        <div>
                                            {edit ? (
                                                <Select
                                                    options={option}
                                                    value={option.find((option: any) => option.value === leaveType) || null}
                                                    onChange={hanldeUpdateLeaveType}
                                                    onInputChange={handleInputChange1}
                                                    onMenuOpen={handleMenuOpen1}
                                                    onMenuClose={handleMenuClose1}
                                                    onFocus={handleFocus1}
                                                    onBlur={handleBlur1}
                                                    menuIsOpen={menuIsOpen1}
                                                    isSearchable
                                                    placeholder={<Placeholder1 />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator1,
                                                    }}
                                                    className="custom-select3"
                                                />
                                            ) : (
                                                <IonInput
                                                    type="text"
                                                    value={leaveTypeList.find(state => state.id === leaveType)?.leaveType || ''}
                                                    disabled
                                                    className="form-control"
                                                />
                                            )}

                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>From Date <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput value={fromDate} disabled={edit === true ? false : true} onIonChange={(e: any) => updateLeavecal(e, true)} className="form-control datetimepicker" type="date" min={currentDate} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Reason for Leave <span className="text-danger">*</span></label>
                                        <IonInput value={leaveReason} disabled={edit === true ? false : true} onIonChange={(e: any) => setLeaveReason(e.detail.value)} className="form-control" />
                                    </div>

                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Reporting Person's </label>
                                        <IonInput value={reportingPerson} readonly className="form-control" />
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>To Date <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput value={toDate} disabled={edit === true ? false : true} onIonChange={(e: any) => updateLeavecal(e, false)} className="form-control datetimepicker" type="date" min={fromDate} />
                                        </div>
                                    </div>

                                    {status1 != "Open" ?
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Remarks </label>
                                            <IonInput value={remarks} readonly className="form-control" />
                                        </div> : <></>}


                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Status </label>
                                        <select value={status} disabled className="select" style={{
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                        }} >
                                            <option selected disabled value="">Approve/Reject</option>
                                            {statusList.map((state: any) => (
                                                <option key={state.id} value={state.id}>
                                                    {state.status}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>No Of Days <span className="text-danger">*</span></label>
                                        {edit === true ? (
                                            <Select
                                                options={dd}
                                                value={dd.find((option: any) => option.value === no)}
                                                defaultValue={dd.find((option: any) => option.value === no)}
                                                // value={selectedOptions || null}
                                                // value={generateDayOptions1().find((option) => option.value === NoOfDays) || setNoOfDays(generateDayOptions1()[0].value) || null}
                                                // onChange={(selectedOption) => setNoOfDays(selectedOption?.label || "")}
                                                onChange={handletypes}
                                                isDisabled={edit === true ? false : true}
                                                styles={{
                                                    control: (provided: any) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                    }),
                                                    placeholder: (provided: any) => ({
                                                        ...provided,
                                                        color: 'black',
                                                    }),
                                                }}
                                            />
                                        ) : (
                                            <IonInput
                                                value={NoOfDays}
                                                disabled={!edit}
                                                onIonChange={(e: any) => setNoOfDays(e.detail.value)}
                                                className="form-control"
                                            />
                                        )}
                                    </div>
                                </div>
                                {isLoading && (
                                    <div
                                        style={{
                                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                        }}
                                    >
                                        <div >
                                            <IonSpinner style={{
                                                width: "40px",
                                                height: "40px",
                                                color: "#ff8a53"
                                            }} name="lines" />
                                        </div>
                                    </div>
                                )}

                                {status1 === "Open" ?
                                    <div className="row-leave" style={{ display: "flex", justifyContent: "center", marginTop: "10%" }}>

                                        {edit === true ? (
                                            <button type="button" className="btn-primary btn-lg" style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }} onClick={() => Update()}>Update</button>
                                        ) : (
                                            <button type="button" className="btn-#00000 btn-lg" style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }} onClick={() => closemodal()}>Back</button>

                                        )}
                                        <button type="button" className="btn-primary btn-lg" style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }} onClick={() => editModal()}>Edit</button>
                                        <button type="button" className="btn-danger btn-lg" style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }} onClick={() => CancelLeave()}>Cancel Leave</button>
                                    </div>

                                    : <div className="row-leave">
                                        <div className="col-md-12" style={{ display: "flex", justifyContent: "center" }}>
                                            <button type="button" className="btn-primary btn-lg" onClick={() => closemodal()}>Back</button>
                                        </div>
                                    </div>}

                            </div>
                        </div>
                        {/* </form> */}
                    </div>
                </Modal>

                {/* {-------------------Apply Leave Modal----------------------} */}

                <Modal dialogClassName="my-modal modal-dialog-centered" show={modalopen1}>
                    <div className="modal-header">
                        <h5 className="modal-title">Apply Leave</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="stats-info applyleave">
                                        <h6 style={{ fontWeight: "bold" }}>Earned Leave</h6>
                                        <h4 style={{ fontWeight: "bolder" }}>{earned}</h4>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="stats-info applyleave">
                                        <h6 style={{ fontWeight: "bold" }}>Sick Leave</h6>
                                        <h4 style={{ fontWeight: "bolder" }}>{sick}</h4>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="stats-info applyleave">
                                        <h6 style={{ fontWeight: "bold" }}>Casual Leave</h6>

                                        <h4 style={{ fontWeight: "bolder" }}>{casual}</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6 col-sm-12 form-group">
                                        <label style={{ fontWeight: "bold" }}>Employee Id <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput value={empCode} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12 form-group">
                                        <label style={{ fontWeight: "bold" }}>Leave Type <span className="text-danger">*</span></label>
                                        <div>
                                            <Select
                                                options={options}
                                                value={options.find((option: any) => option.value === leave) || null}
                                                onChange={hanldeLeaveType}
                                                onInputChange={handleInputChange}
                                                onMenuOpen={handleMenuOpen}
                                                onMenuClose={handleMenuClose}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                menuIsOpen={menuIsOpen}
                                                isSearchable
                                                placeholder={<Placeholder />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicator,
                                                }}
                                                className="custom-select3"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12 form-group">
                                        <label style={{ fontWeight: "bold" }}>From Date <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput
                                                value={fDate}
                                                onIonChange={(e: any) => Leavecal(e, true)}
                                                className="form-control datetimepicker"
                                                type="date"
                                                min={currentDate}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12 form-group">
                                        <label style={{ fontWeight: "bold" }}>To Date <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput
                                                value={tDate}
                                                onIonChange={(e: any) => Leavecal(e, false)}
                                                className="form-control datetimepicker"
                                                type="date"
                                                min={fDate}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12 form-group">
                                        <label style={{ fontWeight: "bold" }}>No Of Days <span className="text-danger">*</span></label>
                                        <Select
                                            options={noofdays}
                                            value={noofdays.find((option: any) => option.value === days)}
                                            onChange={handletype}
                                            onInputChange={handleInputChange2}
                                            onMenuOpen={handleMenuOpen2}
                                            onMenuClose={handleMenuClose2}
                                            onFocus={handleFocus2}
                                            onBlur={handleBlur2}
                                            menuIsOpen={menuIsOpen2}
                                            isSearchable
                                            placeholder='Select No.of.Days'
                                            components={{
                                                DropdownIndicator: DropdownIndicator2,
                                            }}
                                            className="custom-select3"
                                        />
                                    </div>
                                    {isLoading && (
                                        <div
                                            style={{
                                                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                            }}
                                        >
                                            <div >
                                                <IonSpinner style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    color: "#ff8a53"
                                                }} name="lines" />
                                            </div>
                                        </div>
                                    )}

                                    <div className="col-md-6 col-sm-12 form-group">
                                        <label style={{ fontWeight: "bold" }}>Reason<span className="text-danger">*</span></label>
                                        <textarea value={leaveRea} onChange={(e) => setLeaveRea(e.target.value)} className="form-control" />
                                    </div>
                                </div>
                                <div className="submit-section">
                                    <button type="button" className="btn btn-primary submit-btn" onClick={Save}>Submit for Approval</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>
            </IonContent>

        </IonPage>
    )
}

export default LeaveApply;